import { FiltroRMV } from './interfaces/filtrorbancos.entity';
import { EncMovBancos } from './ListadoBancos/banco-movimientos.entity';
import { Bancos, Conciliar, Filtro } from './listado-bancos/bancos.entity';
import { Filtrosaxa } from './reportes/artxalmacen/filtros.entity';
import { EncInventario } from './movimientos/movimientos.entity';
import { Documentos } from './documentos/documentos.entity';
import { Encventa,  TipoPagos } from './ventas/ventas.entity';
import { RegistroKardex } from './reportes/filtros.entity';
import { Encabezado } from './compras/compras.entity';
import { Iva } from './iva/iva.entity';
import { Usuarios } from './usuarios/usuarios.entity';
import { Filtros } from './reportes/rinventario/rinventario.entity';
import { Filtros as Filtrar } from './reportes/filtros.entity';

import { GrupoArt } from './grupoart/grupoart.entity';
import { Almacenes, Ubicaciones } from './almacenes/almacenes.entity';
import { Clientes } from './clientes/clientes.entity';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Proveedores } from './proveedores/proveedores.entity';
import { Usuario } from '../login/login.entity';
import { Empleados } from './empleados/empleados.entity';
import { Articulos } from './articulos/articulos.entity';
import { CierreAdm, Empresa, FiltroResumenCXC } from './configuracion/configuracion.entity';
import { Monedas } from './monedas/monedas.entity';
import { MultiMoneda } from './multimoneda/multimoneda.entity';
import { Basicos, Retenciones } from './basicos/basicos.entity';
import { map } from 'rxjs/operators';
import { Chofer } from './ventas/chofer.entity';
import { FiltroCxp, PagosProv } from './interfaces/filtrocxp.entity';
import { Recuperar, Reestablecer } from './recuperar-clave/recuperar.entity';
import { Maquinaria } from './produccion/maquinarias.entity';
import { Componente } from './produccion/componentes.entity';
import { ActualizarCostos, RegistrarProduccion } from './produccion/produccion.entity';
import { Turno } from './produccion/turnos.entity';
import { Ciudad, Estado, Pais } from './localidades/localidades.entity';
import { ProcesarAlmacenista, ProcesarGuia } from './logistica/procesos/logistica.entity';
import { ActualizarDocumento, Consultar } from './logistica/autorizar/models.entity';
import { Almacenista, Logistica, Filtros as FiltroLogistica, Mesas } from './logistica/despachos/transporte.entity';
import { ConfigService } from '../config.service';
import { ValorMM } from './valormm/valormm.entity';

@Injectable({
  providedIn: 'root'
})
export class ServicesSunsetService {


    private urlImagen = 'https://inventarios.sunsetmanager.com/apiInventario';

    //private url = "http://localhost:4002/api";
    
  //private url = "https://wssunsetmanager.herokuapp.com/api";

    private url: string = "";

   /* {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': '*',
  } */

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Content-Type': 'text/xml',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Headers': '*',
    })
  };


   httpOptionsMP = {
    headers: new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      // 'Content-Type': 'text/xml',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Headers': '*',
    })
  };

  headers : HttpHeaders[] =[];
  items = new HttpHeaders();

  constructor(private http: HttpClient,private config: ConfigService) {
    
      this.url = this.config.apiUrl;
   
   }


   generarPdf(data:any, nombre: string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    
    return this.http.post(`${ this.url }/basicos/generarpdf`,{'name': nombre, 'data' : data}, OptHeader).pipe(
      map ( (data: any) => {

     
        return data;

      }

      )
    );

  }


  validarFechaCierreAdm(valor:any) {

    var valido = false;
    
    var f1 = new Date();
    var f2 = new Date(valor);

    var cierresAdm: any[] = [];
    
    cierresAdm = JSON.parse(sessionStorage.getItem("cierreadm") || "")  ;

    f2.setDate(f2.getDate()+1);

    console.log("extrayendo información...");
     
    cierresAdm.forEach((element:any) => {
      
      f1 = new Date(element.ca_fecha);
      console.log("validando información...");
    
      if (f1.getFullYear() === f2.getFullYear() && f1.getMonth() === f2.getMonth() && element.ca_activo == -1) {
        
          valido = true;

      }


    });

    console.log("resultado información...", valido);

    return valido;

  }


  validaExcel() {

    const ve = parseInt(sessionStorage.getItem('excel') || "0") * 1;


    return  ve;
          

  }

  validaPdf() {

    const ve = parseInt(sessionStorage.getItem('pdf') || "0") * 1;


    return  ve;

  }

   obtenerPdf(id:string) {

    return this.http.get(this.url+'/assets/pdf/'+id, this.httpOptions).pipe (

      map (data => {

        return data;

      })

    );


   }


   obtenerMenu() {

    return this.http.get('./../../assets/json/menu.json', this.httpOptions).pipe (

      map (data => {

        return data;

      })

    );


   }

   NuevoID()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    
    return this.http.get(`${ this.url }/basicos/nuevoid`, OptHeader).pipe(
      map ( (data: any) => {

     
        return data.id;

      }

      )
    );

  }


  Configuracion() {

    return this.http.get('./../../assets/json/configurar.json', this.httpOptions).pipe (

      map (data => {

        return data;

      })

    );

  }


// CRUD Egreso Bancos

GuardarEgresoBancos(encCxc: EncMovBancos) {


  const token = sessionStorage.getItem('token');
  
  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  encCxc.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/egreso-bancos`, encCxc, OptHeader);

}

eliminarRenglonesCxp(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/egreso-bancos/renglones?idd=${idd}&id=${id}`, OptHeader);

}


  // CRUD Ingreso Bancos

  GuardarIngresoBancos(encCxc: EncMovBancos) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


    encCxc.token = sessionStorage.getItem('idd') || '';
    
    return this.http.post(`${ this.url }/ingreso-bancos`, encCxc, OptHeader);

  }

  eliminarRenglonesCxc(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });

    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/ingreso-bancos/renglones?idd=${idd}&id=${id}`, OptHeader);

  }

  eliminarEncCxc(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });

    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/ingreso-bancos?idd=${idd}&id=${id}`, OptHeader);

  }


  consultarEncCxc(id: string) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });

    const idd = sessionStorage.getItem('idd') || '';

  
    return this.http.get(`${ this.url }/ingreso-bancos?idd=${idd}&id=${id}`, OptHeader);


  }

   getPagosDocumentosVentas(tipo_doc: string,numero:number) {

  const token = sessionStorage.getItem('token');
  const idd = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  
    return this.http.get(`${ this.url }/ingreso-bancos/pagos-documentos-ventas`, { ...OptHeader, params: { idd, tipo_doc,numero }});


  }

    getAnticiposPendientesCXC(codcli:string) {

    const token = sessionStorage.getItem('token');
    const idd = sessionStorage.getItem('idd') || '';

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


    return this.http.get(`${ this.url }/ingreso-bancos/anticipos-cxc`, { ...OptHeader, params: { idd, codcli }});


  }


  //CRUD Ingresos Bancos

  seleccionarEmpresa(idd: string) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.get(`${ this.url }/empresas?idd=${idd}`, OptHeader);


  }

  obtenerIdUsuario(correo: string) {

  
  
    return this.http.get(`${ this.url }/recuperarclave/${correo}`, this.httpOptions);


  }

  validarToken(idd: string) {

  
  
    return this.http.get(`${ this.url }/recuperarclave/validarid/${idd}`, this.httpOptions);


  }


  enviarCorreoRecuperacion(recuperar: Recuperar) {

  
    return this.http.post(`${ this.url }/recuperarclave`,recuperar, this.httpOptions);


  }

  reestablecerPassword(reestablecer: Reestablecer) {

  
    return this.http.put(`${ this.url }/recuperarclave`,reestablecer, this.httpOptions);


  }


  consultarEncCxp(id: string) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/egreso-bancos?idd=${idd}&id=${id}`, OptHeader);


  }

  eliminarEncCxp(id: number) {

    const token = sessionStorage.getItem('token');
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.delete(`${ this.url }/egreso-bancos?idd=${idd}&id=${id}`, OptHeader);
  
    }
  

  // CRUD Retencion Paises
  ConsultarPaises() {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    return this.http.get(`${ this.url }/paises?idd=${idd}&id=0`, OptHeader);
  
  }

  EliminarPais(id: number) {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    return this.http.delete(`${ this.url }/paises?idd=${idd}&id=${id}`, OptHeader);
  
  }

  ActualizarPais(pais: Pais) {

  const token = sessionStorage.getItem('token');

  pais.token = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.post(`${ this.url }/paises`, pais, OptHeader);

  }

    // CRUD Retencion Estados
    ConsultarEstados() {

      const token = sessionStorage.getItem('token');
  
      const idd = sessionStorage.getItem('idd') || '';
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      return this.http.get(`${ this.url }/estados?idd=${idd}&id=0`, OptHeader);
    
    }
  
    EliminarEstado(id: number) {
  
      const token = sessionStorage.getItem('token');
  
      const idd = sessionStorage.getItem('idd') || '';
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      return this.http.delete(`${ this.url }/estados?idd=${idd}&id=${id}`, OptHeader);
    
    }
  
    ActualizarEstado(estado: Estado) {
  
    const token = sessionStorage.getItem('token');
  
    estado.token = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    return this.http.post(`${ this.url }/estados`, estado, OptHeader);
  
    }
  
    // CRUD Retencion Ciudades
        ConsultarCiudades() {

          const token = sessionStorage.getItem('token');
      
          const idd = sessionStorage.getItem('idd') || '';
        
          var OptHeader = this.httpOptions;
        
          OptHeader = 
        
            ({
              headers: this.httpOptions.headers.set('x-token', token || ''),
            });
        
        
          return this.http.get(`${ this.url }/ciudades?idd=${idd}&id=0`, OptHeader);
        
        }
      
        EliminarCiudad(id: number) {
      
          const token = sessionStorage.getItem('token');
      
          const idd = sessionStorage.getItem('idd') || '';
        
          var OptHeader = this.httpOptions;
        
          OptHeader = 
        
            ({
              headers: this.httpOptions.headers.set('x-token', token || ''),
            });
        
        
          return this.http.delete(`${ this.url }/ciudades?idd=${idd}&id=${id}`, OptHeader);
        
        }
      
        ActualizarCiudad(ciudad: Ciudad) {
      
        const token = sessionStorage.getItem('token');
      
        ciudad.token = sessionStorage.getItem('idd') || '';
      
        var OptHeader = this.httpOptions;
      
        OptHeader = 
      
          ({
            headers: this.httpOptions.headers.set('x-token', token || ''),
          });
      
      
        return this.http.post(`${ this.url }/ciudades`, ciudad, OptHeader);
      
        }
      

  // CRUD Retencion IVA

  ConsultaRetencionesIva() {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    return this.http.get(`${ this.url }/retencioniva?idd=${idd}&id=0`, OptHeader);
  
  }

  EliminarRetencionesIva(id: number) {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    return this.http.delete(`${ this.url }/retencioniva?idd=${idd}&id=${id}`, OptHeader);
  
  }

  ActualizarRetencionesIva(retIva: Retenciones) {

  const token = sessionStorage.getItem('token');

  retIva.token = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.post(`${ this.url }/retencioniva`, retIva, OptHeader);

  }

  // CRUD Retencion ISLR

ConsultaRetencionesIslr() {

  const token = sessionStorage.getItem('token');

  const idd = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.get(`${ this.url }/retencionislr?idd=${idd}&id=0`, OptHeader);

}

EliminarRetencionesIslr(id: number) {

  const token = sessionStorage.getItem('token');

  const idd = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.delete(`${ this.url }/retencionislr?idd=${idd}&id=${id}`, OptHeader);

}

ActualizarRetencionesIslr(retIslr: Retenciones) {

  const token = sessionStorage.getItem('token');

  retIslr.token = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;
  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.post(`${ this.url }/retencionislr`, retIslr, OptHeader);

}


  // CRUD Choferes

ConsultarChoferes(id: number) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/choferes?idd=${idd}&id=${id}`, OptHeader);

}

actualizarChoferes(chofer: Chofer) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  chofer.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/choferes`, chofer, OptHeader);

}

 // CRUD Cierres Administrativos y Contables

 ConsultarCierreAdm(id: number) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/cierreadm?idd=${idd}&id=${id}`, OptHeader);

  
}

actualizarCierreAdm(cierreAdm: CierreAdm) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  cierreAdm.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/cierreadm`, cierreAdm, OptHeader);

}


eliminarCierreAdm(id: number) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/cierreadm?idd=${idd}&id=${id}`, OptHeader);

}

// CRUD Turnos

ConsultarTurno(id: number) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/turnos?idd=${idd}&id=${id}`, OptHeader);

}

actualizarTurnos(turno: Turno) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  turno.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/turnos`, turno, OptHeader);

}

EliminarTurno(id: number) {

  
  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/turnos?idd=${idd}&id=${id}`, OptHeader);

}


// CRUD Bancos

ConsultarBancos(id: string) {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/bancos?idd=${idd}&id=${id}`, OptHeader);

}

guardarCuentasBancarias(banco: Bancos) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });

  return this.http.post(`${ this.url }/bancos`, banco, OptHeader);

}

modificarCuentasBancarias(banco: Bancos) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.put(`${ this.url }/bancos`, banco, OptHeader);

}

eliminarCuentasBancarias(id: string) {

  const token = sessionStorage.getItem('token');

  const idd = sessionStorage.getItem('idd') || '';

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  return this.http.delete(`${ this.url }/bancos?idd=${idd}&id=${id}`, OptHeader);

}

conciliarMov(datos: Conciliar) {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  datos.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/bancos/conciliar`, datos, OptHeader);

}

desconciliarMov(datos: Conciliar) {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  datos.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/bancos/desconciliar`, datos, OptHeader);

}



  // CRUD Documentos

  MostrarDocumentos()  {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.get(`${ this.url }/documentos?idd=${idd}&id=`, OptHeader);

  }

  guardarDocumento(documento: Documentos) {

    const token = sessionStorage.getItem('token');

    documento.token = sessionStorage.getItem('idd') || '';

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.post(`${ this.url }/documentos`, documento, OptHeader);

  }

  modificarDocumento(documento: Documentos) {

    const token = sessionStorage.getItem('token');

    documento.token = sessionStorage.getItem('idd') || '';

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.put(`${ this.url }/documentos`, documento, OptHeader);

  }


  eliminarDocumento(documento: Documentos) {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.delete(`${ this.url }/documentos?idd=${idd}&id=${documento.td_tipo}`, OptHeader);
  }


   // CRUD Articulos

  MostrarArticulos()  {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    
      
    return this.http.get(`${ this.url }/articulos?idd=${idd}`, OptHeader);

  }

  guardarArticulo(articulo: Articulos) {

    const token = sessionStorage.getItem('token');

    articulo.token = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    return this.http.post(`${ this.url }/articulos`, articulo, OptHeader);

  }

  modificarArticulo(articulo: Articulos) {

    const token = sessionStorage.getItem('token');

    articulo.token = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    return this.http.put(`${ this.url }/articulos`, articulo, OptHeader);

  }


  eliminarArticulo(articulo: Articulos) {

    const token = sessionStorage.getItem('token');

    articulo.token = sessionStorage.getItem('idd') || '';
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    
    const idd = sessionStorage.getItem('idd') || '';
    return this.http.delete(`${ this.url }/articulos?idd=${idd}&id=${articulo.codigo}`, OptHeader);
  }

  MostrarArticulosVentas(buscar:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00001&buscar=${buscar}`, OptHeader);

  }

  MostrarNcAnticipo(codprov:string, codcli:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00018&codprov=${codprov}&codcli=${codcli}`, OptHeader);

  }

  MostrarReporteCxc(filtros: FiltroResumenCXC)  { // Muestra los movimientos diarios de inventarios

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    filtros.token = idd;
    return this.http.post(`${ this.url }/consultas`, filtros, OptHeader);

  }


  MostrarMovInventarios(filtros: Filtros)  { // Muestra los movimientos diarios de inventarios

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    filtros.token = idd;
    return this.http.post(`${ this.url }/consultas`, filtros, OptHeader);

  }

  ConsultarDeudaCxp(filtros: FiltroCxp)  { // Muestra los movimientos diarios de inventarios

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    filtros.token = idd;
    return this.http.post(`${ this.url }/consultas`, filtros, OptHeader);

  }

  verificarDeuda(filtros: PagosProv)  { // Muestra los movimientos diarios de inventarios

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    filtros.token = idd;
    return this.http.post(`${ this.url }/consultas`, filtros, OptHeader);

  }

  //  CRUD Almacenes

   MostrarAlmacenes()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/almacenes?idd=${idd}&id=0`, OptHeader);

  }

  reajustarCostos(tipo: number, codart: string, fhasta: string )  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/almacenes/reajustar?idd=${idd}&tipo=${tipo}&codart=${codart}&fhasta=${fhasta}`, OptHeader);

  }


  guardarAlmacen(almacen: Almacenes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    almacen.token = idd ;

    return this.http.post(`${ this.url }/almacenes`, almacen, OptHeader);

  }

  modificarAlmacen(almacen: Almacenes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    almacen.token = idd;

    return this.http.put(`${ this.url }/almacenes`, almacen, OptHeader);

  }


  eliminarAlmacen(almacen: Almacenes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/almacenes?idd=${idd}&id=${almacen.id_alm}`, OptHeader);
  }

  eliminarUbicacion(id: number) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/ubicaciones?idd=${idd}&id=${id}`, OptHeader);
  
  }

  reajustarCostosKardex(costos: ActualizarCostos[]) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    costos[0].token = idd;

    return this.http.post(`${ this.url }/almacenes/reajustarcostos`, costos, OptHeader);

  }

  // CRUD CLIENTES

  MostrarClientes()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/clientes?idd=${idd}&id=0`, OptHeader);

  }

  MostrarCliente(id: string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/clientes?idd=${idd}&id=${id}`, OptHeader);

  }


  MostrarClientesVentas(buscar:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';


    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00002&buscar=${buscar}`, OptHeader);

  }

  guardarCliente(cliente: Clientes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    cliente.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/clientes`, cliente, OptHeader);

  }

  modificarCliente(cliente: Clientes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    cliente.token = sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/clientes`, cliente, OptHeader);

  }

  eliminarCliente(cliente: Clientes) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';


    return this.http.delete(`${ this.url }/clientes?idd=${idd}&id=${cliente.codigo}`, OptHeader);
  }

  // CRUD PROVEEDORES
  MostrarProveedores()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/proveedores?idd=${idd}&id=0`, OptHeader);

  }

  MostrarProveedor(codigo: string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/proveedores?idd=${idd}&id=${codigo}`, OptHeader);

  }

  MostrarProveedoresVentas(buscar:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00003&buscar=${buscar}`, OptHeader);

  }

  guardarProveedor(proveedor: Proveedores) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    proveedor.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/proveedores`, proveedor, OptHeader);

  }

  modificarProveedor(proveedor: Proveedores) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    proveedor.token = sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/proveedores`, proveedor, OptHeader);

  }

  eliminarProveedor(proveedor: Proveedores) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/proveedores?idd=${idd}&id=${proveedor.id}`, OptHeader);
  }

  // CRUD EMPLEADOS
  MostrarEmpleados()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/empleados?idd=${idd}&id=0`, OptHeader);

  }

  MostrarEmpleadosVentas(buscar:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00004&buscar=${buscar}`, OptHeader);

  }

  MostrarBeneficiariosVentas(buscar:string)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=00017&buscar=${buscar}`, OptHeader);

  }

  guardarEmpleado(empleado: Empleados) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    empleado.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/empleados`, empleado, OptHeader);

  }

  modificarEmpleado(empleado: Empleados) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    empleado.token = sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/empleados`, empleado, OptHeader);

  }

  eliminarEmpleado(empleado: Empleados) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/empleados?idd=${idd}&id=${empleado.id}`, OptHeader);
  }

  // Usuarios

  ValidarUsuario(usuario: Usuario) {

   
    return this.http.post(`${ this.url }/login`, usuario , this.httpOptions ).pipe (

      map (data => {

        return data;

      })

    );



  }

  // Consultas

  ConsultasBasicas(tipo: string, buscar: string) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=${tipo}&buscar=${buscar}`, OptHeader );

  }

  ConsultarConciliaciones(data: Filtros) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    data.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/consultas`, data, OptHeader );

  }


  consultarDashboard(id:string,mes: number, anio: number) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    
    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=${id}&mes=${mes}&anio=${anio}`, OptHeader );

    
  }


  consultarUbicacion(id: number) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';
    return this.http.get(`${ this.url }/ubicaciones?idd=${idd}&id=${id}`, OptHeader );
  }

  ConsultaMovimientoInventario(tipo: string, buscar: string, idAlm: number, tipoMov: number) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/consultas?idd=${idd}&id=${tipo}&buscar=${buscar}&idalm=${idAlm}&tipomov=${tipoMov}`, OptHeader );

  }

  // procesos basicos

  MostrarBasicos(id: number, tipo: number)  {

    const token = sessionStorage.getItem('token');

    const idd = sessionStorage.getItem('idd') || '';


    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });



    return this.http.get(`${ this.url }/basicos?idd=${idd}&id=${id}&tipo=${tipo}`, OptHeader);

  }

  guardarBasicos( basicos: Basicos) {

    const token = sessionStorage.getItem('token');


    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    basicos.token = sessionStorage.getItem("idd") || "";  

    return this.http.post(`${ this.url }/basicos`, basicos, OptHeader);
  }

  modificarBasicos( basicos: Basicos) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    basicos.token = sessionStorage.getItem("idd") || "";

    return this.http.put(`${ this.url }/basicos`, basicos, OptHeader);
  }

  eliminarBasicos(id: number, valor: number, tipo:number) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    const idd = sessionStorage.getItem("idd");

    return this.http.delete(`${ this.url }/basicos?idd=${idd}&id=${id}&valor=${valor}&tipo=${tipo}`, OptHeader);

    
  }

  // CRUD EMPRESA

  MostrarEmpresa()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';
  return this.http.get(`${ this.url }/empresas/${idd}`, OptHeader);

  }

  modificarEmpresa(empresa: Empresa) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    empresa.token = sessionStorage.getItem('idd') || '';
    return this.http.put(`${ this.url }/empresas`, empresa, OptHeader);

  }

  // CRUD MONEDAS

  MostrarMonedas(id: number)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  

  return this.http.get(`${ this.url }/monedas?idd=${idd}&id=${id}`, OptHeader);

  }

  guardarMonedas(moneda: Monedas) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    moneda.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/monedas`, moneda, OptHeader);

  }

  modificarMonedas(moneda: Monedas) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    moneda.token = sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/monedas`, moneda, OptHeader);

  }

  eliminarMoneda(moneda: Monedas) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

    const idd = sessionStorage.getItem('idd') || '';
    return this.http.delete(`${ this.url }/monedas?idd=${idd}&id=${moneda.id}`, OptHeader);
  }

  // CRUD MONEDAS

  MostrarMultiMonedas()  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.get(`${ this.url }/multimonedas?idd=${idd}&id=0`, OptHeader);

  }


   getValorMoneda(dfecha: Date)  {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    const idd = sessionStorage.getItem('idd') || '';

    const fecha = dfecha.toString()

    return this.http.get(`${ this.url }/multimonedas/get-valor-moneda`, { ...OptHeader, params: { idd, fecha } });
   
  }

  guardarMultiMonedas(multimoneda: MultiMoneda) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    multimoneda.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/multimonedas`, multimoneda, OptHeader);

  }

  modificarMultiMonedas(multimoneda: MultiMoneda) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    multimoneda.token = sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/multimonedas`, multimoneda, OptHeader);

  }

  eliminarMultiMoneda(multimoneda: MultiMoneda) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/multimonedas?idd=${idd}&id=${multimoneda.mm_con}`, OptHeader);
  }

// CRUD TIPO ARTICULOS

MostrarTipoArticulos()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/tipoarticulos?idd=${idd}&id=`, OptHeader);

}

eliminarTipoArticulo(valor:string) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/tipoarticulos?idd=${idd}&id=${valor}`, OptHeader);

}

guardarTipoArticulo(gruart: GrupoArt) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  gruart.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/tipoarticulos`,gruart, OptHeader);

}

modificarTipoArticulo(gruart: GrupoArt) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  gruart.token = sessionStorage.getItem('idd') || '';

  return this.http.put(`${ this.url }/tipoarticulos`,gruart, OptHeader);

}

// CRUD Usuarios

MostrarUsuarios(id: string)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/usuarios?idd=${idd}&id=${id}`, OptHeader);

}

guardarUsuario(usuario: Usuarios) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  usuario.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/usuarios`, usuario, OptHeader);
}

modificarUsuario(usuario: Usuarios) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  usuario.token = sessionStorage.getItem('idd') || '';
  
  return this.http.put(`${ this.url }/usuarios`, usuario, OptHeader);
}

// CRUD IVA

MostrarIva()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/iva?idd=${idd}&id=0`, OptHeader);


}

guardarIva(iva: Iva) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  iva.token = sessionStorage.getItem('idd') || '';


  if (iva.fechah == null) {


    iva.fechah = '';

  }


  if (iva.fechah.trim() === '') {

    iva.fechah = '';

  }

   return this.http.post(`${ this.url }/iva`, iva, OptHeader);
}

modificarIva(iva: Iva) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  iva.token = sessionStorage.getItem('idd') || '';


  if (iva.fechah == null) {


    iva.fechah = '';

  }


  if (iva.fechah.trim() === '') {

    iva.fechah = '';

  }


  return this.http.put(`${ this.url }/iva`, iva, OptHeader);

}

eliminarIva(iva: string) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/iva?idd=${idd}&id=${iva}`, OptHeader);

}

// REPORTES

MostrarProductosAlmacen(filtro: Filtrosaxa)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;

  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}


MostrarInventarioGeneral(filtro: Filtros)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;

  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader).pipe (

    map (data => {

      return data;

    })

  );
;

}

MostrarReporteCompras(filtro: Filtros)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';


  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}

MostrarReporteVentas(filtro: Filtros)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}

MostrarReporteGeneral(filtro: Filtros)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}

ReporteBancos(filtro: Filtro)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}

ReporteMovimientosBancos(filtro: FiltroRMV)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}


ProcesarDatos(filtro: Filtrar)  {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  filtro.token = idd;
  return this.http.post(`${ this.url }/consultas`, filtro, OptHeader);

}

  // Procesos

  public  FechaHoraEnEnteroLargo() {

    const fecha = (new Date()).getFullYear();
    let numero: number;
    numero = fecha % 100;
    numero = numero * 12 + (new Date()).getMonth() - 1;
    numero = numero * 31 + (new Date()).getDay() - 1;
    numero = numero * 24 + (new Date()).getHours();
    numero = numero * 60 + (new Date()).getMinutes();
    numero = numero * 60 + (new Date()).getSeconds();
    return numero;
}

// public postFileImagen(imagenParaSubir: File, id, ruta) {

//   const formData = new FormData();
//   formData.append('imagenPropia', imagenParaSubir, id);
//   return this.http.post(`${ this.url }/basicos/loadimagen`, formData);

// }

// public postFileImagen(imagenParaSubir: File, id:any, ruta:string) {

//   const formData = new FormData();
//   formData.append('imagenPropia', imagenParaSubir, id);
//   return this.http.post(`${ this.urlImagen }/${ruta}.php`, formData);

// }


postFileImagen(archivo: File,id:string) {
 
 const formData = new FormData();
  formData.append('archivo', archivo,id);

  const token = sessionStorage.getItem('token');

  const headers = new HttpHeaders()
    .set('x-token', token || '');

  return this.http.post(`${this.url}/uploads-img`, formData, { headers });

 
  // const formData = new FormData();
  // formData.append('archivo', archivo);

  //   const token = sessionStorage.getItem('token');

  //   var OptHeader = this.httpOptionsMP;

  //   OptHeader = 

  //     ({
  //       headers: this.httpOptionsMP.headers.set('x-token', token || ''),
  //     });
  
  //   console.log('Archivo a subir:', archivo);  

  //   return this.http.post(`${ this.url }/uploads-img`, formData, OptHeader);



}



// PROCESO PRINCIPALES

// CRUD COMPRAS

consultarCompras(tipo_doc: string, numero: string, codprov: string, pais: string) {

  const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
  const idd = sessionStorage.getItem('idd') || '';

  
  return this.http.get(`${ this.url }/compras?idd=${idd}&tipo_doc=${tipo_doc}&numero=${numero}&codprov=${codprov}&pais=${pais}`, OptHeader);
}


guardarCompras(compras: Encabezado) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  compras.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/compras`, compras, OptHeader);
}

eliminarCompras(tipo_doc: string, numero: string, codprov: string) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/compras?idd=${idd}&tipo_doc=${tipo_doc}&numero=${numero}&codprov=${codprov}`, OptHeader);
}


eliminarRenglones(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  
  return this.http.delete(`${ this.url }/compras/items?idd=${idd}&id=${id}`, OptHeader);

}

//  Registrar Kardex

RegistrarKardex(kardex: RegistroKardex) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  kardex.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/registrarinventarios`, kardex, OptHeader);
}

RegistrarMovKardex(kardex: EncInventario) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  kardex.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/registrarinventarios`, kardex, OptHeader);

}

ActualizarKardexChofer(kardex: EncInventario) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  kardex.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/registrarinventarios`, kardex, OptHeader);

}

AnularMovKardex(kardex: EncInventario) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  kardex.token = sessionStorage.getItem('idd') || '';

  return this.http.put(`${ this.url }/registrarinventarios`, kardex, OptHeader);

}

EliminarMovKardex(mid_id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';


  return this.http.delete(`${ this.url }/registrarinventarios?idd=${idd}&id=${mid_id}`, OptHeader);
}


// CRUD Ventas

consultarVentas(tipo_doc: string, numero: string, pais: string) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/ventas?idd=${idd}&tipo_doc=${tipo_doc}&numero=${numero}&pais=${pais}`, OptHeader);
}

guardarVentas(ventas: Encventa) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  ventas.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/ventas`, ventas, OptHeader);
}

eliminarVentas(tipo_doc: string, numero: number) {

  const token = sessionStorage.getItem('token');

  const usuario = sessionStorage.getItem('correo');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/ventas?idd=${idd}&tipo_doc=${tipo_doc}&numero=${numero}&usuario=${usuario}`, OptHeader);

}


eliminarRenglonesVentas(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/ventas/items?idd=${idd}&id=${id}`, OptHeader);

}

/** PRODUCCION */
  /** Maquinarias */
consultarMaquinarias(id: number) {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });

    const idd = sessionStorage.getItem('idd') || '';

  
    return this.http.get(`${ this.url }/maquinarias?idd=${idd}&id=${id}`, OptHeader);


  }

  eliminarMaquinaria(maquinaria: Maquinaria) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    const idd = sessionStorage.getItem('idd') || '';

    return this.http.delete(`${ this.url }/maquinarias?idd=${idd}&id=${maquinaria.maq_id}`, OptHeader);
  }


  registrarMaquinaria(maquinaria: Maquinaria) {

    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });

  
    maquinaria.token = sessionStorage.getItem('idd') || '';

    return this.http.post(`${ this.url }/maquinarias`, maquinaria, OptHeader);

  }

  /** Componentes */
  consultarComponentes(id: number) {

    const token = sessionStorage.getItem('token');
  
    var OptHeader = this.httpOptions;
  
    OptHeader = 
  
      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });
  
      const idd = sessionStorage.getItem('idd') || '';
  
    
      return this.http.get(`${ this.url }/componentes?idd=${idd}&id=${id}`, OptHeader);
  
  
    }

    consultarRecetasProduccion(id: string) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
        const idd = sessionStorage.getItem('idd') || '';
    
      
        return this.http.get(`${ this.url }/componentes/recetas?idd=${idd}&id=${id}`, OptHeader);
    
    
      }
  
      consultarRecetasSimular(id: string) {

        const token = sessionStorage.getItem('token');
      
        var OptHeader = this.httpOptions;
      
        OptHeader = 
      
          ({
            headers: this.httpOptions.headers.set('x-token', token || ''),
          });
      
          const idd = sessionStorage.getItem('idd') || '';
      
        
          return this.http.get(`${ this.url }/componentes/simular?idd=${idd}&id=${id}`, OptHeader);
      
      
        }
    

    registrarComponente(componente: Componente) {

      const token = sessionStorage.getItem('token');
  
      var OptHeader = this.httpOptions;
  
      OptHeader = 
  
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
  
    
      componente.token = sessionStorage.getItem('idd') || '';
  
      return this.http.post(`${ this.url }/componentes`, componente, OptHeader);
  
    }  
  
    eliminarComponente(componente: Componente) {

      const token = sessionStorage.getItem('token');
  
      var OptHeader = this.httpOptions;
  
      OptHeader = 
  
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
  
    
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.delete(`${ this.url }/componentes?idd=${idd}&id=${componente.enc_id}`, OptHeader);
    }
  
    eliminarRencomponente(id: number) {

      const token = sessionStorage.getItem('token');
  
      var OptHeader = this.httpOptions;
  
      OptHeader = 
  
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
  
    
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.delete(`${ this.url }/componentes/componentes?idd=${idd}&id=${id}`, OptHeader);
    }
  
    consultarProduccion(id: string ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
  
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.get(`${ this.url }/produccion?idd=${idd}&id=${id}`, OptHeader);
    }

    consultarProducciones(filtro: Filtros ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      filtro.token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion/consulta`, filtro, OptHeader);
    }

    consultarReporteProducciones(filtro: Filtros ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      filtro.token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion/reporteproduccion`, filtro, OptHeader);
    }

    reporteProducciones(filtro: Filtros ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      filtro.token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion/reportes`, filtro, OptHeader);
    }


    consultarComponentesProducido(filtro: Filtros ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      filtro.token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion/componentesproducido`, filtro, OptHeader);
    }

    RegistrarProduccion(kardex: RegistrarProduccion[]) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      kardex[0].token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion`, kardex, OptHeader);
    }

    confirmarProduccion(kardex: RegistrarProduccion) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
    
      kardex.token = sessionStorage.getItem('idd') || '';
    
      return this.http.post(`${ this.url }/produccion/confirmar`, kardex, OptHeader);
    }
    
    obtenerUbicacion(id: string, almacen: number, tipo:number) {

      const token = sessionStorage.getItem('token');
  
      var OptHeader = this.httpOptions;
  
      OptHeader = 
  
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
  
    
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.get(`${ this.url }/consultas?idd=${idd}&id=${id}&buscar=${almacen}&codprov=${tipo}`, OptHeader );
  
    }
  
    anularProduccion(id: string, motivo:string ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
  
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.delete(`${ this.url }/produccion/anular?idd=${idd}&id=${id}&motivo=${motivo}`, OptHeader);
    }

    reabrirProduccion(id: string, clave:string ) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
  
      const idd = sessionStorage.getItem('idd') || '';
  
      return this.http.get(`${ this.url }/produccion/reabrir?idd=${idd}&id=${id}&clave=${clave}`, OptHeader);
    }

    actualizarCostoProduccion(id: string) {

      const token = sessionStorage.getItem('token');
    
      var OptHeader = this.httpOptions;
    
      OptHeader = 
    
        ({
          headers: this.httpOptions.headers.set('x-token', token || ''),
        });
    
        const idd = sessionStorage.getItem('idd') || '';
    
      
        return this.http.get(`${ this.url }/produccion/actualizarcostos?idd=${idd}&id=${id}`, OptHeader);
    
    
      }
    


/** PRODUCCION */

/** LOGISTICA */

getTransportes(filtro: string)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/transportes?idd=${idd}&id=${filtro}`, OptHeader);


}

getPedidosPendientes(filtro: string)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/pedidos-pendientes?idd=${idd}&id=${filtro}`, OptHeader);


}

getAsignados()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/consultar-asignados?idd=${idd}`, OptHeader);


}

getEnProcesos()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/consultar-enprocesos?idd=${idd}`, OptHeader);


}

getAlmacenistas()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/almacenistas?idd=${idd}`, OptHeader);


}

asignarAlmacenista(almacenista: ProcesarAlmacenista)  {

const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
  const idd = sessionStorage.getItem('idd') || '';

  almacenista.token = idd || '';

  return this.http.post(`${ this.url }/logistica/cambio-pedido-asignado`, almacenista, OptHeader);


}


getlistarDocumentos()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/aprobar?idd=${idd}`, OptHeader);


}

getlistadoDespachados(items: FiltroLogistica)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  items.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/logistica/listado-despachados`,items, OptHeader);


}

aprobarPedidos(documento: ActualizarDocumento)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
  const idd = sessionStorage.getItem('idd') || '';

  documento.token = idd || '';

  return this.http.post(`${ this.url }/aprobar`, documento, OptHeader);


}



  detallesCliente(consultar: Consultar) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
    const idd = sessionStorage.getItem('idd') || '';

    consultar.token = idd || '';

    return this.http.post(`${ this.url }/aprobar/consultas`, consultar , OptHeader ).pipe (

      map (data => {

        return data;

      })

    );


  }

  ActualizarPedidosAlmacenista(usuario: Almacenista) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
  const idd = sessionStorage.getItem('idd') || '';

 

      return this.http.get(`${ this.url }/logistica/despachados?idd=${idd}&codigo=${usuario.codigo}`, OptHeader );

  }

  ConsultarDetallesPedido(id: string) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
  const idd = sessionStorage.getItem('idd') || '';


  return this.http.get(`${ this.url }/logistica/detalles-pedido?idd=${idd}&id=${id}`, OptHeader );

  }

actualizarItemsPedido(item: any) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
    const idd = sessionStorage.getItem('idd') || '';

    item.token = idd || '';

    return this.http.post(`${ this.url }/logistica/actualizar-item-pedido`, item , OptHeader ).pipe (

      map (data => {

        return data;

      })

    );

  }

actualizarItemsPedidoSupervisor(item: any) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
    const idd = sessionStorage.getItem('idd') || '';

    item.token = idd || '';

    return this.http.post(`${ this.url }/logistica/actualizar-item-pedido-supervisor`, item , OptHeader ).pipe (

      map (data => {

        return data;

      })

    );

  }

actualizarPedido(item: Logistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


 
    const idd = sessionStorage.getItem('idd') || '';

    item.token = idd || '';

    return this.http.post(`${ this.url }/logistica/actualizar-pedido`, item , OptHeader ).pipe (

      map (data => {

        return data;

      })

    );

  }

   AutorizarSupervisor(id: string) {


    const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


  
    const idd = sessionStorage.getItem('idd') || '';


    return this.http.get(`${ this.url }/logistica/autorizar-supervisor?idd=${idd}&id=${id}`, OptHeader );

  }


ActualizarPedidosSupervisor(usuario: Almacenista) {

     const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


  
    const idd = sessionStorage.getItem('idd') || '';


    return this.http.get(`${ this.url }/logistica/pedidos-supervisor?idd=${idd}`, OptHeader );
   
  }

  

getMesas(id:number)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/mesas?idd=${idd}&id=${id}`, OptHeader);


}

getConsultarZonas(id:number)  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/consultar-zonas?idd=${idd}`, OptHeader);


}


getConsultarTransporteExt()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/consultar-transportes-externo?idd=${idd}`, OptHeader);


  }

ConsultarLog(tipo_doc: string, numero: number) {


   const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/logistica/consultarlog?idd=${idd}&tipo_doc=${tipo_doc}&numero=${numero}`, OptHeader);


  }


  
ListarAyudantes(id_mov:string,usuario:string) {

const token = sessionStorage.getItem('token');

var OptHeader = this.httpOptions;

OptHeader = 

  ({
    headers: this.httpOptions.headers.set('x-token', token || ''),
  });


const idd = sessionStorage.getItem('idd') || '';

return this.http.get(`${ this.url }/logistica/lista-ayudantes?idd=${idd}&id_mov=${id_mov}&usuario=${usuario}`, OptHeader);
  }

getSiguienteGuia()  {

  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return  this.http.get(`${ this.url }/logistica/siguiente-guia?idd=${idd}`, OptHeader).pipe (

    map ((data: any) => {

      return data.consulta[0].guia;

    })

  );      
  }

procesarGuias(guias: ProcesarGuia[])  {

     const token = sessionStorage.getItem('token');

    var OptHeader = this.httpOptions;

    OptHeader = 

      ({
        headers: this.httpOptions.headers.set('x-token', token || ''),
      });


  
    guias[0].token =sessionStorage.getItem('idd') || '';

    return this.http.put(`${ this.url }/logistica/procesar-guias`, guias, OptHeader );
   
  }


  reportePedidosAlmacenistas(items: FiltroLogistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  items.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/logistica/pedidos-almacenistas`, items, OptHeader);


  }


  reporteGuiasTransportes(items: FiltroLogistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  items.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/logistica/reporte-guias-transportes`, items, OptHeader);


  }

  cambiarDespacho(items: Logistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  items.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/logistica/cambiar-despacho`, items, OptHeader);


  }

/** LOGISTICA */


/**Seriales */

  reporteSeriales(filtro: FiltroLogistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  filtro.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/seriales/reporte-seriales`,filtro, OptHeader);


  }


  actualizarSeriales(filtro: any) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  filtro[0].token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/seriales/registrar-seriales`,filtro, OptHeader);


  }

  eliminarSeriales(id:number,mov_idd:string) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/seriales/eliminar-seriales?idd=${idd}&id=${id}&mov_idd=${mov_idd}`, OptHeader);


  }

  consultarItemsSeriales(items: FiltroLogistica) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  items.token = sessionStorage.getItem('idd') || '';

  return this.http.post(`${ this.url }/seriales/consultar-items-seriales`, items, OptHeader);


  }


  
/** Seriales */

/** Mesas */

 actualizarMesas(item: Mesas) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  item.token = sessionStorage.getItem('idd') || '';


  if (item.id == 0) {

    return this.http.post(`${ this.url }/mesas`,item, OptHeader);

  } else {

    return this.http.put(`${ this.url }/mesas`,item, OptHeader);


  }



  }



/** Mesas */


/** Tipo Pagos */


  getTipoPagos() {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/tipopagos`, { ...OptHeader, params: { idd } });


  }

 actualizarTipoPagos(item: TipoPagos) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  item.token = sessionStorage.getItem('idd') || '';


  if (item.tp_id == 0) {

    return this.http.post(`${ this.url }/tipopagos`,item, OptHeader);

  } else {

    return this.http.put(`${ this.url }/tipopagos`,item, OptHeader);


  }



  }

/** Tipo Pagos */

/** Valor MM */

 getValoresMM(id:number) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.get(`${ this.url }/valormm`, { ...OptHeader, params: { idd ,id} });


  }

   actualizarValorMM(item: ValorMM) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  item.token = sessionStorage.getItem('idd') || '';


  if (item.mmv_id === 0) {

    return this.http.post(`${ this.url }/valormm`,item, OptHeader);

  } else {

    return this.http.put(`${ this.url }/valormm`,item, OptHeader);


  }



  }


  eliminarValorMM(id:number) {


  const token = sessionStorage.getItem('token');

  var OptHeader = this.httpOptions;

  OptHeader = 

    ({
      headers: this.httpOptions.headers.set('x-token', token || ''),
    });


  const idd = sessionStorage.getItem('idd') || '';

  return this.http.delete(`${ this.url }/valormm`, { ...OptHeader, params: { idd ,id} });


  }

/** Valor MM */
}

